export default __webpack_public_path__ + "static/media/search-BG.80f05730.png";